<template>
  <modal :show.sync="modal" @close="close()" body-classes="p-0" modal-classes="modal-dialog-centered modal-sm">
    <form rolet="update-tier" class="ml-3 mt-3 mr-3 mb-3" @submit.prevent="updateTier()">
      <h4>Alterar Nível</h4>
      <base-input label="Níveis" required name="niveis">
        <el-select v-model="newTierId" filterable placeholder="Selecione o nível" id="tier" style="width: 100%">
          <el-option v-for="tier in tiers" :key="tier.id" :label="tier.name" :value="tier.id">
          </el-option>
        </el-select>
      </base-input>
      <div class="col-md-12 text-center mt-1">
        <base-button type="primary" native-type="submit">Salvar</base-button>
      </div>
    </form>
  </modal>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  name: 'subscription-change-tier-modal',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: ['modal', 'subscription', 'tiers'],
  emits: ['onClose', 'onChange'],
  data() {
    return {
      newTierId: null,
    }
  },
  methods: {
    updateTier() {
      if (!this.newTierId) {
        this.$notify({ type: 'warning', message: 'Selecione um tier para continuar.' });
        return;
      }
      NProgress.start();
      this.$clubApi.put(`/subscription/${this.subscription.id}/tier`, { tierId: this.newTierId }).then(() => {
        this.$notify({ type: 'success', message: `Operação realizada! O tier da assinatura foi alterado.` });
        this.close();
        this.$emit('onChange');
        this.newTierId = null;
      }).catch((error) => {
        this.$notify({ type: 'warning', message: error.response.data.msg || 'Falha ao alterar o tier.' })
      }).finally(() => {
        NProgress.done();
      });
    },
    close() {
      this.$emit('onClose');
    },
  }
}
</script>
